<template>
  <section id="homePage">

    <b-row class="match-height">
      <b-col
        xl="3"
        md="6"
        v-if="!isFenomen"
      >
        <total-summary />
      </b-col>
      <b-col
        :xl="isFenomen ? '12' : '9'"
        :md="isFenomen ? '12' : '6'"
      >
        <global-summary />
      </b-col>
    </b-row>

    <b-row>
      <b-col
        md="12"
      >
        <b-card class="bg-white">
          <top-product />
        </b-card>
      </b-col>
    </b-row>

    <!-- <b-row>
      <b-col
        md="6"
      >
        <browser-states />
      </b-col>
      <b-col
        md="6"
      >
        <device-services />
      </b-col>
    </b-row> -->
  </section>
</template>

<script>

import { BRow, BCol, BCard } from 'bootstrap-vue'
import TotalSummary from '../components/TotalSummary.vue'
import GlobalSummary from '../components/GlobalSummary.vue'
// import BrowserStates from '../components/BrowserStates.vue'
// import DeviceServices from '../components/devicesCard/DeviceServices.vue'
import TopProduct from './analysis/TopProduct.vue'
export default {
  components: {
    BRow,
    BCol,
    BCard,
    
    TotalSummary,
    GlobalSummary,
    // BrowserStates,
    // DeviceServices,
    TopProduct
  },
  created () {
    
  },
}
</script>

<style>

</style>
